export async function playVideo(el: HTMLVideoElement | null): Promise<void> {
  try {
    await el?.play()
  } catch (err) {
    console.log(err)
  }
}
